export default __webpack_public_path__ + "static/performance_texture-28921f178aa819ef82e23f72c93063c2.png";